/**
 * data 相关联的字段规则
*/
// 默认查询字段
export const defaultFilterForm = {
  branchName:'',
  bankNo:'',
  submitting:false
};
// 分页查询条件
export const defaultListQuery ={
  pageNo: 1,
  pageSize: 20 // 每页显示条数
};

export const defaultDialogForm = {

};
